import React from 'react';

export default function PartnerLoginPage() {
  return (
    <div style={{
      minHeight: '100vh',
      background: '#0a0f1a',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'Barlow, sans-serif',
      padding: '24px',
    }}>
      <div style={{ width: '100%', maxWidth: 440, textAlign: 'center' }}>

        {/* Logo */}
        <div style={{
          width: 56, height: 56, borderRadius: '50%', background: '#fff',
          overflow: 'hidden', margin: '0 auto 20px',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <img src="/logo.png" alt="BTHD" style={{ width: '300%', height: '300%', objectFit: 'contain' }} />
        </div>

        <div style={{ fontFamily: 'Barlow Condensed, sans-serif', fontWeight: 900, fontSize: 22, color: '#fff', letterSpacing: 1, marginBottom: 6 }}>
          BIGGER THAN HOOP DREAMS
        </div>

        {/* Gold accent bar */}
        <div style={{ width: 48, height: 3, background: '#8b6914', borderRadius: 2, margin: '20px auto 32px' }} />

        {/* Icon */}
        <div style={{
          width: 64, height: 64, borderRadius: 16, margin: '0 auto 24px',
          background: 'rgba(139,105,20,0.12)', border: '1.5px solid rgba(139,105,20,0.35)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 28, color: '#c49a1a',
        }}>
          ◇
        </div>

        <div style={{ fontFamily: 'Barlow Condensed, sans-serif', fontWeight: 900, fontSize: 28, color: '#fff', letterSpacing: 0.5, marginBottom: 12 }}>
          Partner Portal
        </div>

        <div style={{
          fontSize: 15, color: 'rgba(255,255,255,0.45)', lineHeight: 1.7, marginBottom: 36, maxWidth: 340, margin: '0 auto 36px',
        }}>
          Coming Soon. Contact us at{' '}
          <a href="mailto:harry@bthd.app" style={{ color: '#c49a1a', textDecoration: 'none', fontWeight: 600 }}>
            harry@bthd.app
          </a>
          {' '}to discuss partnership access.
        </div>

        <a
          href="mailto:harry@bthd.app"
          style={{
            display: 'inline-block',
            padding: '14px 32px', borderRadius: 10,
            background: '#8b6914', color: '#fff',
            fontFamily: 'Barlow Condensed, sans-serif',
            fontWeight: 700, fontSize: 15, letterSpacing: 1,
            textDecoration: 'none',
          }}
        >
          GET IN TOUCH
        </a>

        <div style={{ marginTop: 32 }}>
          <a href="/admin/login" style={{ fontSize: 12, color: 'rgba(255,255,255,0.25)', textDecoration: 'none' }}>
            ← Back to portal selection
          </a>
        </div>

      </div>
    </div>
  );
}
